import { FullscreenLoading } from '@strata/react-fullscreen-loading';
import { BlankScreen } from '@strata/react-page-templates';

import { useCurrentReferralLocation } from 'services/routes';

export const DetermineReferralLocation = () => {
    useCurrentReferralLocation();

    return (
        <>
            <FullscreenLoading isShowing loadingText="Loading referral..." />
            <BlankScreen />
        </>
    );
};
